<template>
  <div class="page">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'标准解读'"/>
      </div>
    </div>
    <div style="width: 1200px;margin: auto;background-color: #FFFFFF;min-height: 500px">
    <el-row v-if="!showDetail"  style="margin-top: 10px;">

      <el-row v-if="imp1" style="text-align:center">
          <el-col style="margin:40px auto 0px auto" >
            <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
          </el-col>
      </el-row>

      <div  v-if="imp">
        <div style="padding-top: 20px">
        <ul v-for="(item,index) in page.list" :key="index" style="padding-right: 40px">
          <li style="list-style-type:none;">
            <span style="font-size:14px" :index="showIndex">{{index+1+'.'}}</span>
            <el-button class="text-box1" style="color: #000000; text-align:left; width: 85%; font-size: 14px;margin-left: 15px;margin-bottom: 10px" type="text" @click="openDetail(item.id)">
              {{item.title}}
            </el-button>
            <span style="text-align: right; font-size: 14px">{{item.createTime.substring(0,10)}}</span>
            <el-divider></el-divider>
          </li>
        </ul>
        </div>
        <el-pagination style="margin-left:80px" :total="page.totalRow" :current-page.sync="page.pageNumber" :page-size.sync="page.pageSize"
                       layout="total, prev, pager, next, jumper"
                       @current-change="getDataList"/>
      </div>
    </el-row>

<!--    <description title="标准解读详情" :visible="showDetail" width="800px" @close="showDetailStd">-->
<!--      <description-item label="标题" v-model="model.title"></description-item>-->
<!--      <description-item  label="内容" ><div v-html="model.content"></div></description-item>-->
<!--      <description-item label="备注" v-model="model.remarks"></description-item>-->
<!--      <description-item label="创建时间" v-model="model.createTime"></description-item>-->
<!--    </description>-->
    <el-row v-if="showDetail" style="margin-top: 10px;">
      <div style="margin-top: 20px">
<!--        <div   @close="showDetailStd">-->
<!--          <div style="text-align: center"><span style="font-size: 18px;font-weight: bold">政策解读详情</span><el-button @click="showDetail=false" style="float: right;padding: 10px">关闭</el-button></div>-->
<!--          <div ><span style="font-weight: bold">标题:</span>{{model.title}}</div>-->
<!--          <div ><span style="font-weight: bold">内容:</span><div v-html="model.content"></div></div>-->
<!--          <div ><span style="font-weight: bold">备注:</span>{{model.remarks}}</div>-->
<!--          <div ><span style="font-weight: bold">创建时间:</span>{{model.createTime}}</div>-->
<!--        </div>-->
        <el-button type="text" icon="el-icon-back" title="返回"
                   style="position: absolute;top:24px;left:20px;font-size: 32px;z-index: 10;"
                   @click="showDetail=false"></el-button>
        <div style="text-align: center">
          <el-row style="font-size: 24px;font-weight: bold">
            <el-col>{{model.title}}</el-col>
          </el-row>
          <el-row style="margin-top: 20px">
            <el-col>创建日期:{{model.createTime}}</el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-divider></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <el-col  :span="22" :offset="1">
              <div style="text-align: left" v-html="model.content">

              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import description from "../../components/Description/description";
import descriptionItem from "../../components/Description/descriptionItem";
import NavigationBar from "./compoment/navigationBar";

export default {
  name:'standardExplain',
  components:{NavigationBar, description, descriptionItem},
  data(){
    return{
      imp1:true,
      imp:false,
      input: "",
      imageUrlTop:require('../../../static/image/home.jpg'),
      systemName:getSystemName(),
      showDetail:false,
      model:{},
      page:{
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      pageQuery:{
        pageNumber: 1,
        pageSize: 20,
        belong: getSystemId(),
      }
    }
  },
  methods:{
    showIndex(index){
      return index+1+'.'
    },
    getDataList(data){
      if(data){
        this.pageQuery.pageSize=data.pageSize
        this.pageQuery.pageNumber=data.pageNumber
      }
      request.post('/standardParse/page',this.pageQuery).then(rsp=>{
        if(rsp.resultCode==='0'){
          this.page=rsp.data
           this.imp1=false;
           this.imp=true;
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
      })
    },
    /**
     * 查看详情
     */
    openDetail(id){
      request({
        url:'/standardParse/get',
        methods: 'get',
        params:{
          id:id
        }
      }).then(rsp=>{
        if(rsp.resultCode=='0'){
          this.model=rsp.data
          console.log('adadad',this.model)
          const regex = new RegExp('<img', 'gi');
          this.model.content=this.model.content.replace(regex, `<img style="max-width: 100%;"`);
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
        this.showDetail=true
      })
    },
    showDetailStd(){
      this.showDetail=false
      this.model={}
    },
    /**
     * 跳转标准查询页
     */
  toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },

  },
  mounted(){
    document.title = this.systemName
    this.getDataList();
  }
}
</script>
<style scoped>
  .text-box1{
    white-space: nowrap;      /*超出的空白区域不换行*/
    overflow: hidden;         /*超出隐藏*/
    text-overflow: ellipsis;  /*文本超出显示省略号*/
  }
  .el-button{
    padding: 0px;
  }
  .el-divider--horizontal{
    margin: 5px 0px 0px 0px;
  }
  Style Attribute {
    font-size: 14px;
  }
  .page{
    background: url("../../../static/image/body-bg.jpg") no-repeat;
    height: 100%;
    width: 100%;
    background-size:100% 775px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/standardExplain.vue